/* eslint-disable import/prefer-default-export */
// let formStateUtil = {};

export const formStateUtil = {
  selectedProduct: { id: 0, name: '' },
  selectedExamCat: { id: 0, name: '' },
  selectedExam: { id: 0, name: '' },
  selectedIssue: { id: 0, name: '', flag: 0 },
  userName: '',
  mobile: '',
  email: '',
  text: '',
  subIssuesArray: [0, 0, 0, 0],
  productData: [],
  examCatData: [],
  examData: [],
  issuesData: [],
};

// export function helper() {
//   return <div>ABCD</div>;
// }

// export default formStateUtil;
